import React from 'react'
import { H1, H4, HEADING_TYPES } from '../Heading/index'
import Button, { TYPES as BUTTON_TYPES } from '../Button/index'

/**
 * The share banner component
 * @param {Map} props.staticText - The static text
 * @returns {JSX.Element} banner component
 */
function SharePageBanner (props) {
  const {
    title,
    text,
    subtitle,
    ctaLabel,
    onOfferClick,
    offerLink,
  } = props

  return (
    <div className="share-page__banner">
      <div className="share-page__banner-container">
        <H1 as={HEADING_TYPES.H2} className="share-page__title share-page__banner-title">{title}</H1>
        <p className="share-page__banner-text">{text}</p>
        <H4 className="share-page__banner-subtitle">{subtitle}</H4>
        { ctaLabel && offerLink && (
          <Button
            className="share-page__banner-cta"
            type={BUTTON_TYPES.PRIMARY}
            onClick={onOfferClick}
            {...offerLink}
          >
            {ctaLabel}
          </Button>
        )}
      </div>
    </div>
  )
}

export default SharePageBanner
